import { audio } from './AudioManager.js';

class QuestManager {
  constructor() {
    this.hudElem = null;
    this.eyebrowElem = null;
    this.titleElem = null;
    this.subElem = null;
  }

  mount(root) {
    this.hudElem = document.getElementById('hud');
    this.eyebrowElem = document.getElementById('hud-eyebrow');
    this.titleElem = document.getElementById('hud-title');
    this.subElem = document.getElementById('hud-subtitle');
  }

  setQuest(title, subtitle = '', eyebrow = '') {
    if (this.titleElem) {
      this.titleElem.innerText = title;
      if (subtitle && this.subElem) this.subElem.innerText = subtitle;
      if (eyebrow && this.eyebrowElem) this.eyebrowElem.innerText = eyebrow;
      audio.playQuestUpdate();

      const hudLeft = document.querySelector('.hud-left');
      if (hudLeft) {
        hudLeft.style.transform = 'scale(1.04)';
        setTimeout(() => { if (hudLeft) hudLeft.style.transform = 'scale(1)'; }, 300);
      }
    }
  }

  setChapter(chapterName, year = '') {
    if (this.eyebrowElem) {
      this.eyebrowElem.innerText = year ? `${chapterName} • ${year}` : chapterName;
    }
  }

  show(visible = true) {
    if (this.hudElem) {
      if (visible) this.hudElem.classList.remove('hidden');
      else this.hudElem.classList.add('hidden');
    }
  }
}

export const questManager = new QuestManager();
